import { getDateInFormat } from "@domains/utils/reportDates";
export var partnerRegistrationDetailsMapper = function (data) {
    var regDetails = data.data;
    var partnerRegDetails = {
        registrationDetails: [],
    };
    regDetails.forEach(function (item) {
        partnerRegDetails.registrationDetails.push({
            partnerCode: item.partner_code,
            exchangeCode: item.exchange_code,
            exchangeName: item.exchange_name,
            segmentCode: item.segment_code,
            segmentName: item.segment_name,
            registrationNo: item.registration_no,
            registrationDate: getDateInFormat(item.registration_date, "DD MMM YY"),
            refreshDate: getDateInFormat(item.refresh_date, "DD MMM YY"),
        });
    });
    return partnerRegDetails;
};
